module.exports = "<section class=\"container-fluid\">\r\n\r\n  <div class=\"article-title\">Blank</div>\r\n\r\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/page-layouts/fullscreen/fullscreen.component.html
// module id = 754
// module chunks = 32